// ============================================================================
// STOER-WAGNER - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'stoer-wagner',
  name: 'Stoer-Wagner',
  category: 'Graphs',
  complexity: {
    time: 'O(V³)',
    space: 'O(V²)'
  },
  description: 'A global minimum cut algorithm for undirected weighted graphs. It repeatedly finds minimum s-t cuts using a maximum adjacency search and contracts the graph until only two vertices remain.'
};
